import { render, staticRenderFns } from "./checkV2Icon.vue?vue&type=template&id=5358b8b2&"
import script from "./checkV2Icon.vue?vue&type=script&lang=js&"
export * from "./checkV2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports